export default __webpack_public_path__ + "static/media/img3-1.dc7cea65.jpg";